import { render, staticRenderFns } from "./DepotBulkOperationDetail.vue?vue&type=template&id=d19a1222"
import script from "./DepotBulkOperationDetail.vue?vue&type=script&lang=js"
export * from "./DepotBulkOperationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports